import _ from "lodash";
import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { Link, useParams, useRouteMatch } from "react-router-dom";
import { PageTitle, TTSVoiceSelector } from "components/standart";

import IntlMessages from "util/intlMessages";
import { LoadingIcon, setOnChange } from "components/special";
import { Alert } from "reactstrap";
import { AudioPreview, Uploader } from "components/standart";

import { adminAPI } from "redux/api";
import { SwitchValue } from "components/special/forms";

import { apiUrls } from "../init";
import VoiceData from "./Data";

const { api } = adminAPI.actions;

const ContentForm = (props) => {
  const { url } = useRouteMatch();
  const { breadCrumbs, content, setContent } = props;
  const params = useParams();
  const [dataSaved, setDataSaved] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const changeContent = setOnChange(content, setContent);
  breadCrumbs.push({
    title: <IntlMessages id="Sounds.Voices.Form" />,
    url,
  });

  const successAlertRef = useRef(null);

  const saveHandler = () => {
    const onSuccess = (body) => {
      setContent(body);
      setDataSaved(true);
      successAlertRef.current.scrollIntoView();
    };

    const onRequest = () => {
      setDataSaved(false);
    };

    const onFailure = () => {
      setDataSaved(false);
    };

    props.saveContent({ params, body: content }, { onSuccess, onFailure, onRequest });
  };

  const makeSampleHandler = () => {
    const onSuccess = (body) => {
      setContent({ ...content, fileId: body._id });
      setLoading(false);
    };

    const onRequest = () => {
      setContent({ ...content, fileId: null });
      setLoading(true);
    };

    const onFailure = () => {
      setLoading(false);
    };

    props.makeSample({ params, body: content }, { onSuccess, onFailure, onRequest });
  };

  return (
    <div>
      <PageTitle {...breadCrumbs} />

      <div className="row">
        <div className="col-12">
          <div className="roe-card-style">
            <div className="roe-card-body">
              <div ref={successAlertRef}>
                <Alert
                  className="alert-success"
                  isOpen={dataSaved}
                  toggle={() => setDataSaved(false)}
                >
                  <IntlMessages id="saved" />
                </Alert>
              </div>

              <VoiceData {...{ content, setContent }} />

              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="Sounds.Voices.instructions" />
                </label>
                <div className="col-8">
                  <textarea
                    rows={10}
                    name="instructions"
                    value={content.instructions || ""}
                    onChange={changeContent}
                    className="form-control react-form-input"
                    autoComplete="off"
                    required
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="Sounds.Voices.speed" />
                </label>
                <div className="col-8">
                  <input
                    type="number"
                    name="speed"
                    value={content.speed || ""}
                    onChange={changeContent}
                    className="form-control react-form-input"
                    autoComplete="off"
                    required
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="Sounds.Voices.sampleFile" />
                  <button className="btn btn-sm btn-warning pull-right" onClick={makeSampleHandler}>
                    <i className={`fa fa-sync-alt ${isLoading ? "fa-spin" : ""} `} />
                  </button>
                </label>
                <div className="col">
                  {content.fileId && <AudioPreview file={{ _id: content.fileId }} />}
                  <div>
                    <textarea
                      rows={10}
                      name="sampleText"
                      value={content.sampleText || ""}
                      onChange={changeContent}
                      className="form-control react-form-input"
                      autoComplete="off"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="Sounds.Voices.isDefault" />
                </label>
                <div className="col-8 my-auto">
                  <SwitchValue
                    value={content.isDefault}
                    name="isDefault"
                    onChange={changeContent}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="Sounds.Voices.isService" />
                </label>
                <div className="col-8 my-auto">
                  <SwitchValue
                    value={content.isService}
                    name="isService"
                    onChange={changeContent}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="tables.enabled" />
                </label>
                <div className="col-8 my-auto">
                  <SwitchValue value={content.enabled} onChange={changeContent} />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-4 col-auto">
                  <button className="form-control c-primary" type="button" onClick={saveHandler}>
                    <IntlMessages id="save" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const FormButton = (props) => {
  const { contentForm, content } = props;
  return (
    <Link to={contentForm(content)} className="btn btn-secondary btn-sm">
      <i className="fa fa-edit" />
    </Link>
  );
};

export default connect(null, {
  saveContent: api.put(apiUrls.voicesInfo),
  makeSample: api.post(apiUrls.voicesSample),
})(ContentForm);
